var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-page"},[_c('div',{staticClass:"doc-page-middle"},[_c('div',{staticClass:"doc-page-iframe"},[(_vm.url && _vm.sid)?_c('iframe',{ref:"iframe",attrs:{"src":_vm.url}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }